import React from "react";
import "./gallery.css"

export const Gallery = () => {
    return (
        <div class="gallerys">
            <hr></hr>
            <h2>Gallery</h2>
            <div class="boxesm">
                <h1>Youth Meet 2025</h1>
                <div class="iboxm">
                    <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" />
                </div>
                <h1>Youth Meet 2025</h1>
                <div class="iboxm">
                    <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" />
                    <img src="/images/antony.jpg" alt="St. Antony's Church" />
                    <img src="/images/cat-gp.jpg" alt="St. Antony's Church" />
                </div>
            </div>
        </div>
    )
} 